import React, { useState } from "react";
import { Button, Col, Row, Space, Tooltip } from "antd";
import { CommentOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import RenderHtml from "components/UI/RenderHtml/RenderHtml";
import CKETextContent from "views/Segments/CKETextContent/CKETextContent";
import "./Comment.scss"
import { isStringEmpty } from "lib/utils/helperMethods";
import MrTranslate from "lib/MrTranslate/MrTranslate";

// const Comment = (props) => {
//   console.log("Comment props ===>", props)
//   let { value, placeholder, onChange, ckeConfig = {} } = props;
//   const [preview, setPreview] = useState(true);

//   const onTextChanged = (data) => {
//     onChange(data);
//   };

//   const textToRender = !isStringEmpty(value) ? <RenderHtml text={value} /> : "Add comments";
//   const iconToRender = !isStringEmpty(value) ? <EditOutlined /> : <CommentOutlined />;
//   const isAddingComments = textToRender === "Add comments";
//   const tooltipTitle = isAddingComments ? "Add comments" : "Edit comment"
//   const commentButtonClass = `media-comments add-comment ${ckeConfig.overAllComments ? "overall-grade-header": ""}`

//   return (
//     <>
//       {preview ? (
//         <span className="comment-content-wrapper">
//           <Tooltip title={tooltipTitle} placement="right">
//             <Button
//               onClick={() => {
//                 setPreview(false);
//               }}
//               type="text"
//               size="large"
//               icon={iconToRender}
//               className={commentButtonClass}
//               shape="round"
//             >
//               {tooltipTitle}
//             </Button>
//           </Tooltip>
//           <br />
//           {!isAddingComments && textToRender}
//         </span>
//       ) : (
//         <CKETextContent
//           ckeConfig={ckeConfig}
//           value={value}
//           placeholder={placeholder}
//           onChange={onTextChanged}
//         />
//       )}
//     </>
//   );
// };

const Comment = (props) => {
  console.log("Comment props ===>", props)
  let { value, placeholder, onChange, ckeConfig = {}, writingAssistantConfig = {} } = props;
  const [editMode, setEditMode] = useState(false);

  const onTextChanged = (data) => {
    onChange(data);
  };

  const textToRender = !isStringEmpty(value) && <RenderHtml text={value} />;
  const iconToRender = !isStringEmpty(value) ? <EditOutlined /> : <CommentOutlined />;
  const isAddingComments = textToRender === "Add comments";
  const tooltipTitle = isAddingComments ? "Add comments" : "Edit comment"
  const commentButtonClass = `media-comments add-comment ${ckeConfig.overAllComments ? "overall-grade-header": ""}`
  const isCommentExist = textToRender ? true : false

  return (
    <>
      {editMode ? 
        <CKETextContent
        ckeConfig={ckeConfig}
        value={value}
        placeholder={placeholder}
        onChange={onTextChanged}
        writingAssistantConfig={writingAssistantConfig}
      /> : (
        <div className={`${isCommentExist && "transparent-background cursor-pointer"} comment-content-wrapper`}
          onClick={() => {
            if (!ckeConfig.isReadOnly) {
              setEditMode(true)
            }
          }}
        >
          <Space direction="vertical" className="comment-content">
            <span className="action-text">{isCommentExist ? <span><EditOutlined /> &nbsp;<MrTranslate id={"Comment.edit_comment"} /></span> : <span><PlusOutlined /> <MrTranslate id={"Comment.add_comment"} /></span>}</span>
            {textToRender}
          </Space>
        </div>
      )}
    </>
  );
};

export default Comment;